import React, { useEffect, useState } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import { FxmsData } from "../datas/FxData";
import { AttrListEdit } from "./../datas/OpClass";
import { FxUiData } from "../datas/FxUiData";
import { FxmsEvent } from "../actions/FxEvent";
import { FxDataEdit } from "../inputs/FxDataEdit";
import { FxmsPopup, FxWindow } from "../windows/FxWindows";
import Highcharts from "highcharts";

import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
const ReactGridLayout = WidthProvider(RGL);
const ROWHEIGHT = 10;
const COLS = 128;

/**
 * 대시보드
 * 개발자 : T/F팀
 * 개발년월 : 2022.11
 * @param {uiGrpNo} props
 * @returns
 */
export const FxDashBoard = (props) => {

  let { uiGrpNo, userGrpNo } = props;
  const [layout, setLayout] = React.useState([]);
  const [refresh, setRefresh] = React.useState(1);
  const [editable, setEditable] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [xy, setXy] = React.useState({});
  const divId = "FxDashboard" + uiGrpNo;
  const myPros = {
    // className: "layout",
    rowHeight: ROWHEIGHT,
    margin: [0, 0],
    onLayoutChange: function (layout) {
      saveLayout(layout);
    },
    cols: COLS,
    useCSSTransforms: true,
    allowOverlap: true
    // breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
    // cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }
    // transformScale: 0.5,
  };
  const showConfigDialog = () => {
    setModalOpen(true);
  };
  const hideConfigDialog = () => {
    setModalOpen(false);
  };


  //하이챠트 리프레쉬 코드 : 2023 1.12 목 김영상
  //그리드레이아웃의 기본 크기를 지정해 주어도, 챠트가 생성되고 이벤트가 연동되지 않는 구조이기 때문에
  //강제로 리프레쉬 해주어야 함
  const updateHighcharts = () =>{
    for (let i = 0; i < Highcharts.charts.length; i++) {
      if (Highcharts.charts[i] !== undefined) {
        Highcharts.charts[i].reflow();
      }
    }
  }
  useEffect(()=>{
    const refreshCharts = setInterval(()=>{
      updateHighcharts()
    },1000)
    return () => clearInterval(refreshCharts)
  },[])
  //하이챠트 리프레쉬 코드 끝


  /* 콤포넌트 상태가 변경되면 */
  const onItemChanged = (op, data) => {
    if (op === 'removeItem' || op === 'addItem') {
      setRefresh(refresh + 1);
      hideConfigDialog();
    } else if (op === 'modeChange') {
      setEditable(data.editable);
      setRefresh(refresh + 1);
      hideConfigDialog();
    }
  }

  useEffect(() => {

    console.log('*** FxDashboard ***  componentMount', divId, props);

    if (FxmsData.getUserNo() > 0) {
      const datas = makeDashboardItem(FxmsData.getUiGrp(uiGrpNo));
      setLayout(datas.layout);
    }


    function onContextMenu(e) {
      try {
        if (e.target.id === divId || e.target.parentNode.id === divId) {
          let unit = window.innerWidth / COLS;
          setXy({ x: parseInt(e.clientX / unit), y: parseInt(e.clientY / ROWHEIGHT) });
          showConfigDialog();
        }
      } catch (error) {
        console.log(error);
      }
    }

    // 편집권한을 확인하여 보일지 결정한다.
    if (FxmsData.getOpObj('edit-dashboard') != null) {
      document.addEventListener('contextmenu', onContextMenu);
    }

    return (() => {
      document.removeEventListener('contextmenu', onContextMenu);
      try {
        FxmsEvent.stopValuePeeker();
        FxmsEvent.stopAlarmReceiver();
      } catch (error) {
        console.log(error);
      }
    });

  }, []);



  useEffect(() => {
    if (FxmsData.getUserNo() > 0) {
      const datas = makeDashboardItem(FxmsData.getUiGrp(uiGrpNo));
      setLayout(datas.layout);
      console.log('*** FxDashboard ***  refresh', divId, props, refresh, datas);
    }
  }, [refresh]);

  function onLayoutChange(layout) {
    console.log('*** FxDashboard ***', layout);
    this.props.onLayoutChange(layout);
  }
  function onDragStop(layout) {
    // 이동 종료
    saveLayout(layout);
  };
  function handleRightClick(e) {
    e.preventDefault();
  };

  const makeDashboardItem = (fxUiGrp) => {
    const layout = [];

    if (fxUiGrp && fxUiGrp.fxUiGrpItemList) {
      for (let fxUiGrpItem of fxUiGrp.fxUiGrpItemList) {
        if (fxUiGrpItem.opObj) {

          let unit = parseInt(window.innerWidth / COLS);
          const id = 'UI-' + fxUiGrpItem.uiGrpNo + "-" + fxUiGrpItem.uiNo;
          fxUiGrpItem.width = Number(fxUiGrpItem.uiWdth) * unit;
          fxUiGrpItem.height = Number(fxUiGrpItem.uiHght) * ROWHEIGHT;

          try {
            layout.push({ x: fxUiGrpItem.uiX, y: fxUiGrpItem.uiY, w: fxUiGrpItem.uiWdth, h: fxUiGrpItem.uiHght, i: id, moved: false });
          } catch (error) {
            console.log(error);
          }

        }
      }
    }

    return { layout: layout };
  }


  const make = (fxUiGrpItem, key, element, attrListClass = null) => {

    const className = 'FxStyle' + ((editable ? 'Edit' : fxUiGrpItem.uiStyle));

    return (
      <div key={key} className={className}>
        {element}
        {editable ?
          <ItemConfigDialog title='설정' fxUiGrpItem={fxUiGrpItem} onItemChanged={onItemChanged}>
            {attrListClass ?
              <FxDataEdit attrListClass={attrListClass} selectedData={fxUiGrpItem.attrObj} />
              : ""}
          </ItemConfigDialog> : ""}
      </div>
    );
  }

  const [fxUiGrp, setFxUiGrp] = useState(FxmsData.getUiGrp(uiGrpNo))

  return (

    <div className="FxDashBoard" id={divId} onContextMenu={handleRightClick} >
      <ReactGridLayout
        layout={layout}
        onLayoutChange={onLayoutChange}
        className="FxDashBoardLayout"
        isDraggable={editable}
        isResizable={editable}
        // onDrop={onDrop}
        // onBreakpointChange={onBreakpointChange}
        onDragStop={onDragStop}
        {...myPros}
      >
        {/*{dom}*/}
        {FxmsData.getUiGrp(uiGrpNo) && FxmsData.getUiGrp(uiGrpNo).fxUiGrpItemList ? FxmsData.getUiGrp(uiGrpNo).fxUiGrpItemList.map(x => {
          if (x.opObj) {
            const comp = x.opObj.uiCmptName;
            const id = 'UI-' + x.uiGrpNo + "-" + x.uiNo;
            try {
              return make(x, id,
                <FxUiData.makeResource name={comp} key={id} id={id} fxUiGrp={fxUiGrp} fxUiGrpItem={x} editable={editable}
                  onItemChanged={onItemChanged} userGrpNo={userGrpNo} /> // ui 데이터를 찾아서 그려줌
                , FxUiData.getConfig(comp, fxUiGrp, x));
            } catch (error) {
              console.log(error);
              return '';
            }

          }
        }) : ''
        }
      </ReactGridLayout>

      <FxmsPopup open={modalOpen} closeModal={hideConfigDialog} title='대시보드 설정' width={AttrListEdit.makeWidth(650)}>
        <DashboardConfig uiGrpNo={uiGrpNo} onItemChanged={onItemChanged} xy={xy} editable={editable} />
      </FxmsPopup>

    </div>
  );


  /**
   * 크기 변경 레이아웃 기록
   * @param {*} layout
   * @returns
   */

  function saveLayout(layout) {
    let uiGrpItemList = [];
    // const unit = window.innerWidth  / COLS;

    if (editable === false) {
      return;
    }

    for (let l of layout) {
      try {
        let uiGrpItem = {};
        let ss = l.i.split('-');
        uiGrpItem.userNo = FxmsData.getUserNo();
        uiGrpItem.uiGrpNo = parseInt(ss[1]);
        uiGrpItem.uiNo = parseInt(ss[2]);
        uiGrpItem.uiX = l.x;
        uiGrpItem.uiY = l.y;
        uiGrpItem.uiWdth = l.w;
        uiGrpItem.uiHght = l.h;
        uiGrpItemList.push(uiGrpItem)
      } catch (error) {
        console.log(error);
      }
    }

    if (uiGrpItemList.length > 0) {
      FxmsData.updateUiLayout(uiGrpItemList);
      console.log("*** FxDashboard ***", layout);
    }

    return uiGrpItemList.length;
  }


};

/**
 * 대시보드 설정
 * @param {*} props
 * @returns
 */
const DashboardConfig = (props) => {

  const { uiGrpNo, onItemChanged, xy } = props;
  const [attrListClass, setAttrListClass] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState(null);

  useEffect(() => {

    const filterList = new AttrListEdit("filter");
    filterList.makeAttrSelect(40, "opId", "추가할 콤포넌트 선택 ", 300, "component", {}, null);
    filterList.makeAttrButton(41, "cmdAddComponent", "추가하기", 100, null,
      function (data) {
        let opObj = FxmsData.getOpObj(data.opId);
        if (opObj) {
          FxmsData.addUiGrpItem(uiGrpNo, opObj, xy.x, xy.y).then(function (res) {
            FxmsData.reloadUiData(function () {
              onItemChanged('addItem');
            });
          }).catch(function (error) {
            alert("요청한 내용 처리중 오류가 발생하였습니다.");
          })

        }
      }
    );
    filterList.makeAttrCheck(50, "editable", "편집여부", 240,
      function (data) {
        onItemChanged('modeChange', { editable: data.editable === 'Y' });
      }
    )

    setSelectedData({ editable: props.editable });
    setAttrListClass(filterList);

  }, []);


  return <FxDataEdit attrListClass={attrListClass} selectedData={selectedData} />
}

/**
 * 컴포너트의 설정 팝업을 보여준다.
 * @param {*} props
 * @returns
 */
const ItemConfigDialog = props => {

  const { title, fxUiGrpItem, onItemChanged } = props;
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    console.log("*** FxmsCfgDialog ***  props ", props);
  }, []);

  const modalOpen = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const handleClickDelete = () => {

    console.log("*** FxmsCfgDialog ***  handleClickDelete ", fxUiGrpItem);

    if (fxUiGrpItem) {

      FxWindow.confirm('해당 콤포넌트를 삭제할까요?', function (bRet) {
        if (bRet) {
          FxmsData.removeUiGrpItem(fxUiGrpItem.uiGrpNo, fxUiGrpItem.uiNo).then(function (res) {
            FxmsData.reloadUiData(function () {
              onItemChanged('removeItem', { uiGrpItem: fxUiGrpItem });
              FxWindow.alert("해당 컴포넌트가 삭제되었습니다.");
              setOpen(false);
            });
          }).catch(function (error) {
            console.log("*** FxmsCfgDialog *** ", error);
            FxWindow.alert("요청한 내용 처리중 오류가 발생하였습니다.");
          })
        }
      });
    };
  }

  return (
    <div>
      <DeleteIcon fontSize="small" className="DelButton" onClick={handleClickDelete} />
      {(props.children ? <>
        <SettingsIcon fontSize="small" className="CfgButton" onClick={modalOpen} />
        <FxmsPopup open={open} closeModal={closeModal} title={title} width={AttrListEdit.makeWidth(650)}>
          {props.children}
        </FxmsPopup>
      </>
        : null)}
    </div>
  );


}

/**
 * 대시보드 편집 모드일 때 보여줌
 * 개발자 : T/F팀
 * 개발년월 : 2022.12
 * @param {*} props
 * @returns
 */
export const FxDashEditInfo = (props) => {
  return <div className="FxDashEditInfo">
    <p>{props.children}</p>
  </div>;
}

export default FxDashBoard;